import React, {useCallback, useContext, useEffect, useState} from "react";
import {Button, Typography} from "@bezlimit/bezlimit-ui";
import {Table, ConfigProvider, message, notification} from "antd";
import {MobXProviderContext, observer} from "mobx-react";
import {useTranslation} from "react-i18next";
import {CheckboxChangeEvent} from "antd/lib/checkbox";
import _ from "lodash";
import "./style.scss";
// components
import Info from "./info";
import Actions from "./actions";
import Empty from "../../../empty";
import ColumnTitle from "../../../ui/columnTitle";
import Header from "./header";
// core
import {LayoutContext} from "../../../../../core/Contexts";
// services
import PhonesFiltersService from "../../../../../services/PhonesFiltersService";
import PhoneService from "../../../../../services/PhoneService";
import UserService from "../../../../../services/UserService";
import {useSearchParams} from "react-router-dom";
import insurance from "../../../../../images/insurance.svg";
import PhonesBookingService from "../../../../../services/PhonesBookingService";
import successCopy from "../../../../../images/success.png";

export default observer(function NumbersList({
    phone,
    type,
    tariff,
    categories,
    region,
    pattern,
    gridType,
    sort,
    phonePattern,
    phoneCombs,
    Service,
    isFavorite,
    setIsFavorite,
    setType,
    setTariff,
    setCategories,
    setRegion,
    setPattern,
    setPhone,
    setGridType,
    setSort,
    setGridTypePrev,
    setCssClassGrouped,
    setPhonePattern,
    setPhoneCombs
}: IProps) {
    const contextLayout = useContext(LayoutContext);
    const {t} = useTranslation();
    const [data, setData] = useState<any>([]);
    const [cssClass, setCssClass] = useState(false);
    const [isAllChecked, setAllIsChecked] = useState(false);
    const phone_pattern = phonePattern;
    const phone_combs = phoneCombs;
    const totallList = Service.meta?.totalCount;
    const totallPage = Service.totall;
    const [search] = useSearchParams();
    const {store} = useContext(MobXProviderContext);
    const [sortKit, setSortKit] = useState(false);

    const [loading, setLoading] = useState(false);
    const columns = [
        {dataIndex: "info", key: "info"},
        {
            dataIndex: "actions",
            key: "actions",
            ...(_.isEqual(Service.type, "default") && {
                title: (
                    <Header
                        phone={phone}
                        type={type}
                        tariff={tariff}
                        categories={categories}
                        region={region}
                        pattern={pattern}
                        gridType={gridType}
                        sort={sort}
                        phonePattern={phonePattern}
                        phoneCombs={phoneCombs}
                        isFavorite={isFavorite}
                        setIsFavorite={setIsFavorite}
                        setType={setType}
                        setTariff={setTariff}
                        setCategories={setCategories}
                        setRegion={setRegion}
                        setPattern={setPattern}
                        setSort={setSort}
                        setGridType={setGridType}
                        setGridTypePrev={setGridTypePrev}
                        setCssClass={setCssClass}
                        setAllIsChecked={setAllIsChecked}
                        setPhone={setPhone}
                        setPhonePattern={setPhonePattern}
                        setPhoneCombs={setPhoneCombs}
                        Service={Service}
                    />
                )
            })
        }
    ];

    const onClick = async () => {
        setLoading(true);
        try {
            const options = {
                page: Service.currentPage + 1,
                ...PhonesFiltersService.getFormatedFilters({
                    phone,
                    ...(_.isEqual(Service.type, "default") ? {type} : {type: [Service.type]}),
                    tariff,
                    categories,
                    region,
                    pattern,
                    phone_pattern,
                    phone_combs,
                    sort,
                    general_number: PhonesFiltersService.phonesFilters.general_number
                })
            };

            await Service.loadMorePhones(options);
        } finally {
            setLoading(false);
            setAllIsChecked(false);
        }
    };
    const onChange = ({target: {checked}}: CheckboxChangeEvent) => {
        Service.selectedRowKeys = checked ? _.chain(Service.items).map("phone").valueOf() : [];
        setAllIsChecked(checked);
    };

    const cb = useCallback(() => {
        let res = _.chain(Service.items)
            .filter(({type}) => !_.isEqual(type, 9))
            .uniqBy("phone")
            .valueOf();

        const data = _.chain(res)
            .reduce<DataType[]>((res, i) => {
                (res || (res = [])).push({
                    key: i.phone as React.Key,
                    info: (
                        <Info
                            props={i}
                            filters={{
                                phone,
                                type,
                                tariff,
                                categories,
                                region,
                                pattern,
                                phone_pattern,
                                phone_combs,
                                sort,
                                general_number: PhonesFiltersService.phonesFilters.general_number
                            }}
                            Service={Service}
                            gridType={gridType}
                            search={search}
                        />
                    ),
                    actions: (
                        <Actions
                            props={i}
                            filters={{
                                phone,
                                type,
                                tariff,
                                categories,
                                region,
                                pattern,
                                phone_pattern,
                                phone_combs,
                                sort,
                                general_number: PhonesFiltersService.phonesFilters.general_number
                            }}
                            Service={Service}
                            search={search}
                        />
                    )
                });
                return res;
            }, [])
            .valueOf();

        setData(data);
    }, [Service.items, Service.meta, sort, gridType, window.location.search, phone_pattern, phone_combs]);

    useEffect(() => {
        cb();
    }, [Service.items, Service.meta, sort, gridType, window.location.search, phone_pattern, phone_combs]);

    useEffect(() => {
        if (Service.isEqualItemsSizeAndselectedRowKeysSize && Service.selectedRowKeysSize) {
            setAllIsChecked(true);
        } else {
            setAllIsChecked(false);
        }
    }, [Service.selectedRowKeys]);

    useEffect(() => {
        setCssClassGrouped(cssClass);
    }, [cssClass]);

    useEffect(() => {
        return () => {
            Service.cleanUp();
        };
    }, []);

    const rowSelection = {
        onChange: (value: React.Key[]) => {
            Service.selectedRowKeys = value;

            if (!Service.isEqualItemsSizeAndselectedRowKeysSize) {
                setAllIsChecked(false);
            }
        }
    };

    const onClickSort = async () => {
        store.pageLoading = true;
        try {
            await Service.searchPhones(
                {
                    is_reserved: true,
                    sort: "kit"
                },
                {loading: false}
            );
            store.sortKit = true;
        } catch (error) {
        } finally {
            store.pageLoading = false;
        }
    };

    const onClickCopy = () => {
        store.copyKit = !store.copyKit;
        notification.open({
            message: t("Подборка номеров скопирована"),
            placement: "top",
            closeIcon: undefined,
            icon: <img src={successCopy} width={43} alt="" />,
            className: "custom-class",
            // getContainer: () => document.body.querySelector(".list-container")!,
            duration: 2
        });
        store.sortKit = false;
    };

    return (
        <Typography
            as="div"
            className={`bl-numbers-list ${
                UserService.storeCanBookForDelivery ? "is-can-super-booking" : ""
            } ${_.isEqual(_.size(type), 1) && _.includes(type, "paid") ? "paid" : Service.type}${
                _.lte(contextLayout?.width ?? 0, 768) && cssClass ? " mobile-dropdown-open" : ""
            } ${_.gte(contextLayout?.width ?? 0, 768) ? gridType : "kanban"}${
                isFavorite ? " isfav" : ""
            }`}
        >
            <ConfigProvider renderEmpty={() => <Empty />}>
                {store.sortKit ? (
                    <Button
                        onClick={onClickCopy}
                        className="btn-copy-sort-kit"
                        icon={
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M10 2.5H7C5.89543 2.5 5 3.39543 5 4.5V13C5 14.1046 5.89543 15 7 15H15.5C16.6046 15 17.5 14.1046 17.5 13V10"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M11.25 8.75L17.5 2.5M17.5 2.5H13.75M17.5 2.5V6.25"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M1.94849 9.375L1.94852 15.6985C1.94852 17.0386 3.03489 18.125 4.37499 18.125L12.4999 18.125"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        }
                    >
                        {_.gte(contextLayout?.width ?? 0, 768)
                            ? "Копировать подборку"
                            : "Копировать"}
                    </Button>
                ) : (
                    <Button
                        onClick={onClickSort}
                        className="btn-copy-sort-kit"
                        icon={
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M6 3H5C3.89543 3 3 3.89543 3 5L3 17C3 18.1046 3.89543 19 5 19H14C15.1046 19 16 18.1046 16 17V16"
                                    stroke="currentColor"
                                />
                                <path
                                    d="M7 0.5H14.0752C14.4788 0.500014 14.8653 0.662666 15.1475 0.951172L18.0723 3.94238C18.3463 4.22266 18.5 4.59922 18.5 4.99121V15C18.5 15.8284 17.8284 16.5 17 16.5H7C6.17157 16.5 5.5 15.8284 5.5 15V2C5.5 1.17157 6.17157 0.500001 7 0.5Z"
                                    stroke="currentColor"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M14 7L10 7"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M14 11L10 11"
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        }
                    >
                        {_.gte(contextLayout?.width ?? 0, 768) ? "Подборка номеров" : "Подборка"}
                    </Button>
                )}

                <Table
                    rowSelection={{
                        columnTitle: (
                            <ColumnTitle
                                onChange={onChange}
                                disabled={!Service.itemsSize}
                                title={Service.name}
                                checked={isAllChecked}
                            />
                        ),
                        selectedRowKeys: Service.selectedRowKeys,
                        type: "checkbox",
                        ...rowSelection
                    }}
                    columns={columns}
                    dataSource={data}
                    pagination={{
                        defaultPageSize: Service.perPage * Service.currentPage,
                        pageSize: Service.perPage * Service.currentPage,
                        showTitle: false,
                        showSizeChanger: false,
                        showLessItems: true
                    }}
                />

                {Service.hasItems ? (
                    <Button
                        className="load-more"
                        type="default"
                        onClick={onClick}
                        loading={loading}
                    >
                        {t("Показать еще")}
                        {_.isEqual(Service.type, "default") ? (
                            <>{t(`(показано ${totallPage} номеров из ${totallList})`)}</>
                        ) : null}
                    </Button>
                ) : null}
            </ConfigProvider>
        </Typography>
    );
});

interface DataType {
    key: React.Key;
    info: JSX.Element;
    actions: JSX.Element;
}

interface IProps {
    phone: string | undefined;
    type: string[];
    tariff: string[];
    categories: string[];
    region: string[];
    pattern: string[];
    isAllChecked: boolean;
    gridType: string;
    sort: string;
    phonePattern: any;
    phoneCombs: string | undefined;
    Service: PhoneService;
    isFavorite: boolean;
    setIsFavorite: React.Dispatch<React.SetStateAction<boolean>>;
    setType: React.Dispatch<React.SetStateAction<string[]>>;
    setTariff: React.Dispatch<React.SetStateAction<string[]>>;
    setCategories: React.Dispatch<React.SetStateAction<string[]>>;
    setRegion: React.Dispatch<React.SetStateAction<string[]>>;
    setPattern: React.Dispatch<React.SetStateAction<string[]>>;
    setPhone: React.Dispatch<React.SetStateAction<string | undefined>>;
    setGridType: React.Dispatch<React.SetStateAction<string>>;
    setGridTypePrev: React.Dispatch<React.SetStateAction<string>>;
    setSort: React.Dispatch<React.SetStateAction<string>>;
    setCssClassGrouped: React.Dispatch<React.SetStateAction<boolean>>;
    setPhonePattern: React.Dispatch<React.SetStateAction<string[]>>;
    setPhoneCombs: React.Dispatch<React.SetStateAction<string | undefined>>;
}
